import { faBell } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ListItem } from '../../flayr-components/ListItem/ListItem';

interface IProfileFomoSectionProps {
  className?: string;
  watchersCount?: number;
  providerName?: string;
}

const ProfileFomoSection: React.FC<React.PropsWithChildren<React.PropsWithChildren<IProfileFomoSectionProps>>> = ({
  className,
  watchersCount,
  providerName = 'the provider',
}) => {
  return (
    <div data-testid="fomo" hidden={!watchersCount} className={className}>
      <ListItem
        leftIcon={<FontAwesomeIcon icon={faBell} />}
        leftIconClassName="self-start pt-1 text-red-500 md:text-orange-400 text-2xl"
        titleClassName="font-medium text-sm md:text-base"
        title={`${watchersCount} other ${
          (watchersCount === 1 && 'person') || 'people'
        } looking to book ${providerName} for the same date`}
        subTitle="Book soon to avoid missing out."
        subTitleClassName="text-xs md:text-sm font-medium text-gray-500 leading-tight mt-1 text-red-400 md:text-orange-400"
        rightIcon={null}
      />
    </div>
  );
};
export default ProfileFomoSection;
